module.exports = __webpack_public_path__ + "img/back7.f05838eb.png";